import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { CONTACTFORM_ANLIEGEN_SUPPORT, PAGEDIALOG_CONTACT } from '../constants';
import { setPageDialogOpenId } from '../reducers/app';

import IconChat3 from './Icons/IconChat3';

function StickyButtonNew({ cssClasses }) {
  const [scrollDirection, setScrollDirection] = useState('down');
  const scrollDirectionRef = useRef('down'); // 🧠 aktuelle Scrollrichtung
  const prevScrollTopRef = useRef(0); // 🧠 vorherige Scrollposition
  const throttleTimeout = useRef(null);

  const dispatch = useDispatch();
  if (!cssClasses) cssClasses = '';

  const handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop;

    const prevScrollTop = prevScrollTopRef.current;
    const currentDirection = scrollDirectionRef.current;

    if (scrollTop < prevScrollTop && currentDirection !== 'up') {
      setScrollDirection('up');
      scrollDirectionRef.current = 'up';
    } else if (scrollTop > prevScrollTop && currentDirection !== 'down') {
      setScrollDirection('down');
      scrollDirectionRef.current = 'down';
    }

    prevScrollTopRef.current = scrollTop;
  };

  useEffect(() => {
    const onScroll = () => {
      if (throttleTimeout.current === null) {
        throttleTimeout.current = setTimeout(() => {
          handleScroll();
          throttleTimeout.current = null;
        }, 500); // ⏱️ Throttle-Zeit
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (throttleTimeout.current) {
        clearTimeout(throttleTimeout.current);
      }
    };
  }, []);

  const openForm = () => {
    localStorage.setItem('mysreal_contact_reason', CONTACTFORM_ANLIEGEN_SUPPORT);
    dispatch(setPageDialogOpenId(PAGEDIALOG_CONTACT));
  };

  return (
    <div className={`stickyButton ${cssClasses} ${scrollDirection === 'down' ? 'scrolled' : ''}`} onClick={openForm}>
      <IconChat3 />
      {scrollDirection === 'up' ? <span>Support</span> : null}
    </div>
  );
}

export default StickyButtonNew;